<!--suppress ALL -->
<template>
    <div id="summary_schedule_visit_date" class="service-content-padding">

        <div class="row hidden" :id="'timeSummery_' + service.service_id"></div>
        <div class="ibox date-time-box scheduled-visits-js mobile-ibox-margin-visit"
             v-show="canAppointmentBeDisplayed">
            <div v-if="hasDateStyle"
                 class="ibox-title p-bottom-12 p-top-20px mobile-p-bottom-schedule title-appointment-margin">
                <div class="form-group m-left--12 appointment-container">
                    <h4 class="col-md-4 appointment-title">  Scheduled Appointments   </h4>
                    <div class="col-md-6 col-md-offset-2 add-btn-mobile-position">
                        <div class="btn-group pull-right m-0-mobile">
                            <span data-toggle="dropdown" class="float-right" aria-expanded="false">
                                <a href="javascript:;" class="add-icon">
                                    <svg width="20" style="fill: #2E4051;" height="20" viewBox="0 0 20 20" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10
                                        18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                                              fill="#03A9F4"/>
                                    </svg>
                                </a>
                            </span>
                            <span data-toggle="dropdown" aria-expanded="false"
                                  class="select-services-dropdown-add-label float-right">
                                <a href="javascript:;" style="text-decoration: none; color: #2E4051">Add</a>
                            </span>
                            <ul class="dropdown-menu">
                                <li><a @click="addMoreTimeForService(service,visits);">Add new appointment</a></li>
                                <li class="divider"></li>
                                <li><a @click="addRecurringAppointment(service,visits)">Add recurring appointment</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ibox-content appointment-ibox-style">

                <div v-show="canAppointmentBeDisplayed" ref="visits" :id="`booking_visits_${service.service_id}_${service.clone}`">


                        <appointment-visit v-for="(visit,index) of visits" :key="visit.uniqueKey"
                                           :service="service" v-model="visits[index]"
                                           :booking-status="bookingStatus"
                                           @appointmentVisitsMounted="onAppointmetVisitssMounted"
                                           :item-id="itemId" :item-type="itemType"
                                           :index="index" :displayCopyDates="displayCopyDates"
                                           :duplicate="duplicate" :hasDate="hasDate">

                        </appointment-visit>


                </div>
            </div>
        </div>
        <div :id="`multiple_days_${service.service_id}_${service.clone}`"></div>
    </div>
</template>

<script>
import {getBookingStatuses} from "@/modules/common/api";
import {drawVisits} from "@/modules/Services/api/appointments"
import _ from "lodash";
import {EventBus} from "@/events/event-bus";
import {addMoreTimeForService} from "@/events/sharedMethods.js";
export default {
    name: "Appointments",
    props: {
        service: {
            type: Object,
            required: true
        },
        itemType: {
            required: true
        },
        duplicate: {
          default() {
            return false
          }
        },
        loggedUser: {
            required: true
        },
        itemId: {},
        value: {
            type: Array,
            // requried: true
        },
      displayCopyDates: {},
      hasDate: {
          type: Boolean
      },
      bookingStatuses:{
        type: Array
      }
    },
    data() {
        return {
            booking: {
                status: null
            },
            visitsRenderedCount:false,
            visits: this.value,
            allowGetAvailableFieldworkers: this.service.itemId === null || this.service.add_from_edit || this.itemType === 'inquiry',
            hasDateStyle: this.itemType !== 'estimate',
            bookingStatus: null,
            deletedAppointments:[],
        }
    },
    computed: {
        id() {
            if (parseInt(this.service.clone)) {
                return `multiple_days_${this.service.service_id}_${this.service.clone}`;
            }

            return `multiple_days_${this.service.service_id}`;
        },

        partOfDays() {
            return this.visits.map(visit => visit.isPartOfDay)
        },
        contractors() {
            this.visits.map(visit => visit.contractorId)
        },
        deletedAppointmentsString: {
            get() {
                return this.deletedAppointments.join(",");
            },
            set(value) {
                this.deletedAppointments = value.split(",").map(Number);  // Convert back to array of numbers
            }
        }
    },
    methods: {
        onAppointmetVisitssMounted(){
            this.visitsRenderedCount++;
            if (this.visitsRenderedCount === this.visits.length) {
            this.$emit('appointmentsMounted');
            }
        },
        isBookingStatus(type) {
            const bookingStatus = $("#bookingStatus").val();

            if (this.booking.status.hasOwnProperty(type))
                return this.booking.status[type][0].booking_status_id === bookingStatus

            return false;
        },
        isBookingType(type) {
            return this.itemType === type;
        },

        handleDeleteAppointment(index) {
            this.$delete(this.visits, index);
            //this.visits.splice(index, 1);

        },

        getBookingStatuses() {
            getBookingStatuses()
                .then(response => {
                    this.booking.status = _(response.data).groupBy('name').value();
                    this.bookingStatus = response.data.filter(item => item.booking_status_id == $("#bookingStatus").val())[0];
                });
        },
        getAvailableFieldworkers(service) {
            if (this.allowGetAvailableFieldworkers){
                EventBus.$emit('getAvailableFieldWorkersRequest',this.service.service_id,this.service.clone)
            }
        },
        addRecurringAppointment(service) {
            this.addRecurringAppointmentModal(service.service_id, service.clone)
        },
        addRecurringAppointmentModal(service_id,clone){
          console.log(service_id,clone)
          if($("#recurring_service_id").val()!=service_id){
            //reset popup
            $(".contentAppointment").removeClass("hidden");
            $('#here_table').html("");
          }
          $("#start_time").val($(".appointment_row_"+service_id + "_" + clone + " #visit_0_" +service_id + "_" + clone + "_startTime").val())
          $("#end_time").val($(".appointment_row_"+service_id + "_" + clone + " #visit_0_" +service_id + "_" + clone + "_endTime").val())
          $("#recurring_service_id").val(service_id);
          $("#recurring_clone").val(clone);
          $("#recurring_estimate_time").val($(".estimate_time_"+service_id+"_"+clone).val());
          $("#repeat_appointments_modal").find(".modal-title").html("Add recurring appointment");
          $("#repeat_appointments_modal").modal('show');
        },
        canAppointmentBeDisplayed() {
            return !(this.isBookingType('estimate') ||
                this.isBookingStatus('GIFT CARD') ||
                this.isBookingStatus('QUOTED') ||
                this.isBookingStatus('TO SCHEDULE'));
        },
        copyVisitsDates(targetVisit,visitToCopy){
          targetVisit.startDate = visitToCopy.startDate
          targetVisit.startTime = visitToCopy.startTime
          //Update end date and time after watch startdate changes that apply estimate hours to end date
          this.$nextTick(()=>{//Without nexTick it will not take effect and estimate time will affect it
            targetVisit.endDate = visitToCopy.endDate
            targetVisit.endTime = visitToCopy.endTime
            targetVisit.uniqueKey = this.uuidv4();//re-render Appointmentvisit component
          })
          targetVisit.is_all_day_event = visitToCopy.is_all_day_event
          targetVisit.part_of_day = visitToCopy.part_of_day

        },
        drawAppointments() {
            drawVisits({
                service_id: this.service.service_id,
                clone: this.service.clone,
                toEstimate: $("#toEstimate").val(),
                toInvoice: $("#toInvoice").val(),
                booking_id: this.service.itemId,
                isProducts: $("#isProducts").val(),
                default_start_time: this.service.defaultStartTime,
                default_fieldworker_id: this.service.defaultFieldworkerId,
                default_start_date: this.service.defaultStartDate,
                default_end_date: this.service.defaultEndDate,

            }).then(response => {
                this.visits = _.cloneDeep(response.data.visits);
                this.service.meta = response.data
                delete this.service.meta.visits;
                delete this.service.visits;
                if(this.service.defaultStartDate){
                  this.visits.splice(0,this.visits.length)
                }
                 if (!this.visits || this.visits.length < 1)
                    this.visits.push({})
                this.visits.forEach(item => {

                    item.startDate = item.startDate ?? (this.service.defaultStartDate ? this.service.defaultStartDate : moment().format(this.service.meta.MomentDateFormat));
                    item.startTime = item.startTime ?? (this.service.defaultStartTime ? this.service.defaultStartTime : moment().format(this.service.meta.JsTimeFormat));
                    item.endDate = item.endDate??this.service.defaultEndDate;
                    item.endTime = item.endTime??this.service.defaultEndTime;
                    item.calculateDuration = true
                    item.fieldworkerChanged =false;
                    item.oldContractorId = item.contractor_id;
                    item.oldContractorName = item.username;

                    item.serviceName = this.service.service_name;
                    if(this.service.defaultFieldworker){
                        let defaultFieldworker = '';
                        if(typeof  this.service.defaultFieldworker == "object"){
                             defaultFieldworker = this.service.defaultFieldworker
                        }else{
                             defaultFieldworker = JSON.parse(this.service.defaultFieldworker)
                        }
                        if (defaultFieldworker){
                            item.contractor_id = defaultFieldworker.user_id
                            item.contractor_text = defaultFieldworker.contractor_text
                            item.contractor_img = defaultFieldworker.contractor_img
                        }
                    }

                    item.timezone = item.timezone ?? this.service.meta.settingsTimezone;
                     item.subworkers = item.subworkers? item.subworkers:[];
                });

                EventBus.$emit('getAvailableFieldWorkersRequest',this.service.service_id,this.service.clone)
                this.$nextTick(()=>{
                  EventBus.$emit('onAddDeleteAppointment')
                  if(typeof (fieldworkerPopover)!="undefined"){
                    fieldworkerPopover.init($(".fieldworker-hover-summary"),'/contractor-details');
                  }
                })
                let vm =this;
                    this.$nextTick(()=>{
                        setTimeout(function (e){
                            if (vm.service.itemId  && !document.getElementById('booking_services_added')){
                                // Create a new input element
                                let input = document.createElement('input');
                                // Set the attributes
                                input.type = 'hidden';
                                input.id = 'booking_services_added';
                                // Append the input to the body
                                document.body.appendChild(input);
                            }})
                        },1000)
            })
        },
        addEventListeners() {
            EventBus.$on('onServiceCustomFieldSelected', (service_id,clone) => {
                if (service_id === this.service.service_id && clone === this.service.clone) {
                    this.getAvailableFieldworkers(this.service);

                }
            })
            EventBus.$on('fieldworkerAssignedToGeneral', () => {
                this.drawAppointments();
            })

            EventBus.$on('onBookingStatusChange', (statues) => {
                this.hasDateStyle = statues.has_date;
                this.bookingStatus = statues;
            })

            EventBus.$on('multipleVisitsSelected', (selectedMultipleVisits, service_id,clone) => {
                for (let i = 0; i < selectedMultipleVisits.length; i++ ){
                  if(this.service.service_id == service_id && this.service.clone ==clone){
                      // Loop through each property in this.visits[0]
                      for (let prop in this.visits[0]) {
                          // If the property doesn't already exist in selectedMultipleVisits[i]
                          if (!selectedMultipleVisits[i].hasOwnProperty(prop)) {
                              // Add the property to selectedMultipleVisits[i]
                              selectedMultipleVisits[i][prop] = this.visits[0][prop];
                              selectedMultipleVisits[i]['timezone'] = this.visits[0]['timezone'];
                          }
                      }
                      let new_visit = selectedMultipleVisits[i];
                      new_visit.uniqueKey = this.uuidv4();
                      new_visit.id = 0;
                      new_visit.visit_status = null;
                      new_visit.visit_confirmed = null;
                      this.visits.push({...new_visit});
                  }
                }
            })
            EventBus.$on(`applyDatesToAll_${this.service.service_id}_${this.service.clone}`, (visitToCopy,apply_with_index=false,index=0) => {
                EventBus.$emit('serviceChanged', this.visits);
              if(apply_with_index){
                this.copyVisitsDates(this.visits[index],visitToCopy)
              }else{//Apply across all services
                this.visits.forEach((visit)=>{
                  this.copyVisitsDates(visit,visitToCopy)
                })
              }
            })


        },

        uuidv4() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        makeServiceReadonly() {
            if (document.getElementById('view_booking') && !document.getElementById('booking_services_added')){

                // Target all child elements inside the form
                var allInsideForm = document.querySelectorAll("#fmEdit *");

                for (var i = 0; i < allInsideForm.length; i++) {
                    var elem = allInsideForm[i];
                    // Exclude the editButton from being modified
                    if (elem.id === "editButton") {
                        continue;
                    }
                    if (elem.tagName === "INPUT" || elem.tagName === "SELECT") {
                        elem.setAttribute("readonly", "true");
                    }
                    elem.classList.add("no-user-select");       // Prevent text selection
                    elem.setAttribute("contenteditable", "false");
                }
                // Target all elements with class "rotate" and enable mouse interactions
                var rotateElements = document.querySelectorAll(".rotate");
                rotateElements.forEach(function(elem) {
                    elem.style.pointerEvents = "auto";
                });
                // Target all elements with class "rotate" and enable mouse interactions
                var addIcon = document.querySelectorAll(".add-icon");
                addIcon.forEach(function(elem) {
                    elem.style.pointerEvents = "auto";
                });
                document.getElementById('selectServiceDropDown').style.display ='none';
            }
        },
        addMoreTimeForService,
    },
    created() {
      if(this.bookingStatuses){
        this.booking.status = _(this.bookingStatuses).groupBy('name').value();
        this.bookingStatus = this.bookingStatuses.filter(item => item.booking_status_id == $("#bookingStatus").val())[0];
      }else{
        this.getBookingStatuses()
      }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.allowGetAvailableFieldworkers) {
                this.getAvailableFieldworkers(this.service);
            }
            this.allowGetAvailableFieldworkers = true;
        });
        if (!this.visits ){
            this.drawAppointments();
        }

        this.addEventListeners();

        // this.$nextTick(() => {
        //     $('.only-picker-date').datetimepicker({format: this.service.meta.JsTimeFormat});
        // })
    },
    updated() {
        // let vm = this;
        // this.$nextTick(() => {
        //     vm.makeServiceReadonly();
        // });
    },
    watch: {
        visits: {
            handler(newVisits,oldVisits) {
                console.log(JSON.stringify(newVisits) !== JSON.stringify(oldVisits));
                if (JSON.stringify(newVisits) !== JSON.stringify(oldVisits)) {
                    EventBus.$emit('serviceChanged', newVisits);
                }
                this.$emit('input', newVisits);
            },
            deep: true,
            immediate: true,
        }
    }
}
</script>

<style scoped>
.service-content-padding {
    background-color: #F5F5F6;
}

.title-appointment-margin {
    background-color: #F5F5F6;
    color: #000;
    border: none
}

.appointment-container {
    margin-bottom: 5px;
}

.add-btn-mobile-position {
    text-align: right;
}

.appointment-ibox-style {
    padding-top: 0;
}

.ibox-title-padding {
    border-width: 0;
}

.mobile-ibox-content-appointment {
    padding-bottom: 0;
    border-width: 0 0;
}

.only-picker-date {
    cursor: pointer !important;
    background-color: white !important;
}

.showNotesBTN {
    padding-right: 51px;
}

.estimate-fieldworker {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    padding-left: 30px !important;
}

.select2-container--open .select2-dropdown {
    /*left: 1px !important;*/
    /*width: 570px  !important;*/
    top: 16px !important;
}

.contractor_sub button {
    padding: 12px 16px !important;
    gap: 10px !important;
    width: 570px !important;
    height: 48px !important;
    border: 1px solid #EAECEE !important;
    border-radius: 8px !important;
}

.contractor_sub .dropdown-menu.open {
    /*width: 143% !important;*/
    width: 570px !important;
    left: 1px !important;
}

.sub_fieldworker_btn button, .sub_fieldworker_btn button:hover, .sub_fieldworker_btn button:focus, .sub_fieldworker_btn button:active, .sub_fieldworker_btn button.active, .open > .dropdown-toggle.sub_fieldworker_btn button > .btn-default {
    color: #000000 !important;
    background-color: #FFFFFF !important;
}

.send-job-request-div {
    margin-top: 20px;
}

@media (max-width: 767px) {
    .showNotesBTN {
        padding-right: 0px;
        padding-bottom: 0px;
    }

    .row.showNotesBTN {
        padding-bottom: 0px;
    }

    .contractor_sub .dropdown-menu.open {
        width: 95% !important;
    }

    .fieldworker-box .select2-container--default .select2-selection--single .select2-selection__arrow {
        left: 95% !important;
        width: 0px !important;

    }

    .select2-container--default .select2-selection--single .select2-selection__arrow b {
        margin-left: -14px;
    }

    .select2-container--open .select2-dropdown {
        width: 84% !important;
    }

    .fieldworker-box .select2-selection__rendered {
        padding: 9px 12px !important;
    }

    .fieldworker-box .select2-container--default .select2-selection--single .select2-selection__placeholder {
        padding-top: 3px;
    }

    .note-box {
        margin-right: -5px !important;
    }

    .m-0-mobile {
        margin: 0px;
    }

    .appointment-container {
        margin-bottom: 0px;
    }

    .appointment-title{
        margin: 0px;
    }
}

/*For Tablets*/
@media (min-width: 768px) and (max-width: 1023px) {
    .fieldworker-box .select2-container--default .select2-selection--single .select2-selection__arrow {
        left: 95% !important;
    }
}

.estimate-fieldworker {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    padding-left: 30px !important;
}

.select2-container--open .select2-dropdown {
    /*left: 1px !important;*/
    /*width: 570px  !important;*/
    top: 16px !important;
}

.contractor_sub button {
    padding: 12px 16px !important;
    gap: 10px !important;
    width: 570px !important;
    height: 48px !important;
    border: 1px solid #EAECEE !important;
    border-radius: 8px !important;
}

.contractor_sub .dropdown-menu.open {
    /*width: 143% !important;*/
    width: 570px !important;
    left: 1px !important;
}

.sub_fieldworker_btn button, .sub_fieldworker_btn button:hover, .sub_fieldworker_btn button:focus, .sub_fieldworker_btn button:active, .sub_fieldworker_btn button.active, .open > .dropdown-toggle.sub_fieldworker_btn button > .btn-default {
    color: #000000 !important;
    background-color: #FFFFFF !important;
}

.reminder-booking-btn {
    padding-left: 0px;
}

.apply_all_container_fieldworker {
    margin-top: 25px;
}

.actions-container {
    margin-left: 0;
    margin-bottom: 0;
}

@media (max-width: 767px) {
    .showNotesBTN {
        padding-right: 0px;
        padding-bottom: 0px;
    }

    .row.showNotesBTN {
        padding-bottom: 0px;
    }

    .contractor_sub .dropdown-menu.open {
        width: 95% !important;
    }

    .fieldworker-box .select2-container--default .select2-selection--single .select2-selection__arrow {
        left: 95% !important;
        width: 0px !important;

    }

    .select2-container--default .select2-selection--single .select2-selection__arrow b {
        margin-left: -14px;
    }

    .select2-container--open .select2-dropdown {
        width: 84% !important;
    }

    .fieldworker-box .select2-selection__rendered {
        padding: 9px 12px !important;
    }

    .fieldworker-box .select2-container--default .select2-selection--single .select2-selection__placeholder {
        padding-top: 3px;
    }

    .note-box {
        margin-right: -5px !important;
    }

    .actions-container {
        padding: 0;
    }

    .m-bottom-0-mobile {
        margin-bottom: 0;
    }
}

/*For Tablets*/
@media (min-width: 768px) and (max-width: 1023px) {
    .fieldworker-box .select2-container--default .select2-selection--single .select2-selection__arrow {
        left: 95% !important;
    }
}
</style>